<template>
  <div id="settingsQRPayment">
    <div class="container">

      <Tabs>
        <TabSection :title="$t('qr_payment.requirements_validation')">
          <TipsPayAtTheTableStatus @valid="valid = $event"></TipsPayAtTheTableStatus>
        </TabSection>

        <TabSection v-if="valid && payAtTheTable" :title="$t('settings.tip_configuration')">
          <div class="columns">
            <div class="column">
              <div class="feature">
                <div class="feature-name">{{ $t('qr_payment.enable_tip') }}</div>
                <select v-model="payAtTheTable.tipsActivated">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>
              <template v-if="payAtTheTable.tipsActivated">
                <div class="feature">
                  <div class="feature-name">{{ $t("settings.tip_options") }}</div>
                  <div class="tip" v-for="(tip, tipIndex) of tipOptions" :key="tipIndex">
                    <input class="tip-input" type="text" v-model="tipOptions[tipIndex]"
                      :class="{ invalid: $validate.error('payAtTheTable.tipOptions') }">
                    <svgicon src="icon/close.svg" :height="12" :width="12" @click="removeTip(tipIndex)"></svgicon>
                  </div>
                  <div class="add-tip" @click="addTip">
                    <svgicon src="icon/add.svg" :height="12" :width="12"></svgicon>
                  </div>
                </div>
                <div class="feature" v-if="tipOptions && tipOptions.length > 0">
                  <div class="feature-name">{{ $t("settings.default_tip_value") }}</div>
                  <Tooltip :text="$t('settings.default_tip_value')"></Tooltip>
                  <select v-model="payAtTheTable.defaultTipAmount">
                    <option :value="null">{{ $t('choose') }}...</option>
                    <option :value="tip" v-for="tip of tipOptions">{{ tip }} %</option>
                  </select>
                </div>
                <div class="feature">
                  <span class="feature-name" v-html="$t('settings.hide_none_tip_option')"></span>
                  <select v-model="payAtTheTable.hideNoneTipOption">
                    <option :value="true">{{ $t('yes') }}</option>
                    <option :value="false">{{ $t('no') }}</option>
                  </select>
                </div>
              </template>
            </div>
          </div>
          <div class="feature">
            <div class="feature-name">{{ $t('qr_payment.tip_on_total_description') }}</div>
            <select v-model="payAtTheTable.tipOnTotal">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
        </TabSection>

        <TabSection :title="$t('settings.pdf_menu')"
          v-if="payAtTheTable && payAtTheTable.digitalMenu && currentLanguageTab && ready">
          <TipBox info :title="$t('qr_payment.configure_your_digital_menu')">
            <div v-html="$t('qr_payment.digital_menu_description')"></div>
          </TipBox>
          <div class="tabs">
            <div class="tab" :class="{ active: currentLanguageTab === 'en' }" @click="currentLanguageTab = 'en'">
              {{ $t('translation.en') }}</div>
            <div class="tab" :class="{ active: currentLanguageTab === 'fr' }" @click="currentLanguageTab = 'fr'">
              {{ $t('translation.fr') }}</div>
          </div>
          <br>
          <div class="group">
            <input id="chkDigitalMenuFalse" type="radio" :value="false"
              v-model="payAtTheTable.digitalMenu[currentLanguageTab].getFromUrl">
            <label for="chkDigitalMenuFalse">{{ $t('qr_payment.configure_from_uploaded_file') }}</label>
            <input id="chkDigitalMenuTrue" type="radio" :value="true"
              v-model="payAtTheTable.digitalMenu[currentLanguageTab].getFromUrl">
            <label for="chkDigitalMenuTrue">{{ $t('qr_payment.configure_from_url') }}</label>
          </div>
          <br>
          <div class="subtitle">{{ $t(payAtTheTable.digitalMenu[currentLanguageTab].getFromUrl ? 'qr_payment.provide_url' :
            'qr_payment.select_from_file') }}</div>
          <BranchMediaSelector v-if="!payAtTheTable.digitalMenu[currentLanguageTab].getFromUrl"
            ref="documentMediaSelector" document :selected="payAtTheTable.digitalMenu[currentLanguageTab].fileId"
            @changed="selectedDigitalMenuFile($event)"></BranchMediaSelector>
          <div class="group" v-if="payAtTheTable.digitalMenu[currentLanguageTab].getFromUrl">
            <label>{{ $t('qr_payment.file_url') }}</label>
            <input type="text" v-model="payAtTheTable.digitalMenu[currentLanguageTab].fileUrl">
          </div>
        </TabSection>

        <TabSection :title="$t('settings.tables')" v-if="payAtTheTable">
          <TipBox info>
            <span v-html>{{$t('qr_payment.tables_explanation')}}</span>
          </TipBox>
          <div class="group">
            <label>{{ $t('qr_payment.tables') }}</label>
            <textarea v-model="payAtTheTable.tables"></textarea>
          </div>
          <br>
          <div class="group">
            <label v-if="tables.length > 0">{{ $t('qr_payment.your_tables') }}</label>
            <div class="tables">
              <div class="table" v-for="table of tables">
                {{ table }}
                <div class="svg-holder" @click="cropTable(table)">
                  <svgicon src="icon/close.svg" :height="12" :width="12"></svgicon>
                </div>
              </div>
            </div>
          </div>
          <!--<br>
          <div class="subtitle">{{$t('settings.advanced_configurations')}}</div>
          <div class="group">
            <div class="feature">
              <div class="feature-name">{{$t('qr_payment.activate_table_number_scan')}}</div>
              <select v-model="payAtTheTable.tableNumberScanActivated">
                <option :value="true">{{$t('yes')}}</option>
                <option :value="false">{{$t('no')}}</option>
              </select>
            </div>
          </div>-->

          <template v-if="valid">
            <Panel icon="icon/qr-code.svg" collapsible collapsed :title="$t('qr_payment.qr_code.generate_for_url')">
              <QrCodeGenerator key="single_url" :url="url" :description="$t('qr_payment.qr_code.description')">
              </QrCodeGenerator>
            </Panel>

            <!--<Panel icon="icon/qr-code.svg" collapsible collapsed :title="$t('qr_payment.qr_code.generate_for_table_numbers_only')">
              <QrCodeGenerator key="multiple_table_num" :urls="tablesForQrCode" :description="$t('qr_payment.qr_code.description_table_num')"></QrCodeGenerator>
            </Panel>-->

            <br>
            <Panel icon="icon/qr-code.svg" collapsible collapsed
              :title="$t('qr_payment.qr_code.generate_for_table_numbers_with_url')">
              <QrCodeGenerator key="multiple_table_num" :urls="tablesWithUrlsForQrCode"
                :description="$t('qr_payment.qr_code.description_table_url')"></QrCodeGenerator>
            </Panel>
          </template>
        </TabSection>

        <TabSection :title="$t('settings.advanced_configurations')" v-if="payAtTheTable">
          <div class="feature">
            <div class="feature-name">{{ $t('qr_payment.scan_check_only') }}</div>
            <select v-model="payAtTheTable.scanCheckOnly">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
          <div class="feature">
            <div class="feature-name">{{ $t('qr_payment.disable_multi_check_selection') }}</div>
            <select v-model="payAtTheTable.disableMultiCheckSelection">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>
          <Panel :title="$t('qr_payment.enable_create_check')" collapsible>
            <TipBox warning no-border>
              <div v-html="$t('qr_payment.warning_compatibility_description')"></div>
            </TipBox>
            <div class="feature">
              <div class="feature-name">{{ $t('qr_payment.activate_create_check') }}</div>
              <select v-model="payAtTheTable.createCheckActivated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
          </Panel>
        </TabSection>
      </Tabs>

      <div class="footer-actions">
        <button class="btn btn-primary" @click="save">{{ $t('save') }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import TipsPayAtTheTableStatus from "@/components/tips/TipsPayAtTheTableStatus.vue";
  import BranchMediaSelector from "@/components/branch/BranchMediaSelector";
  import QrCodeGenerator from "@/components/QrCodeGenerator.vue";
  import { mapActions } from "vuex";

  export default {
    name: "settingsQRPayment",

    components: { TipsPayAtTheTableStatus, QrCodeGenerator, BranchMediaSelector },

    data() {
      return {
        valid: false,
        ready: false,
        url: null,
        tipOptions: [],
        tablesError: false,
        languages: [],
        currentLanguageTab: 'en',
        payAtTheTable: null
      }
    },

    validate: [{
      "payAtTheTable.tipOptions": {
        required: false,
        regex: /^[0-9]+(,[0-9]+)*$/
      },
      "payAtTheTable.defaultTipAmount": {
        number: true
      },
    }],

    watch: {
      tipOptions: function () {
        this.payAtTheTable.tipOptions = this.tipOptions.join(",");
        let defaultAmount = this.payAtTheTable.defaultTipAmount;
        if (this.tipOptions.indexOf(defaultAmount) === -1) {
          this.payAtTheTable.defaultTipAmount = null;
        }
      }
    },

    computed: {
      tables() {
        if (!this.payAtTheTable.tables || this.payAtTheTable.tables.length === 0) {
          return [];
        }
        let tables = this.payAtTheTable.tables.split(",");
        return tables.map(t => t.trim()).sort((a, b) => a - b).filter(t => !!t);
      },
      tablesForQrCode() {
        return this.tables.map(table => {
          return {
            filename: 'table-number-' + table,
            url: table
          }
        });
      },
      tablesWithUrlsForQrCode() {
        return this.tables.map(table => {
          return {
            filename: 'url-table-' + table,
            url: this.url + "?number=" + table
          }
        });
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "services.qr_payment";
      this.$store.state.pageIcon = "/icon/services.svg";
      let urlFrontend = this.$store.state.contextServer.urlFrontend;
      let company = await this.$store.getters.getContextCompany;
      let branch = await this.$store.getters.getContextBranch;

      this.payAtTheTable = company.payAtTheTable;
      this.url = urlFrontend + "/#/" + branch.nameCanonical + "/" + company.nameCanonical + "/table";

      this.setTips();
      if (this.payAtTheTable) {
        this.payAtTheTable.createCheckActivated = company.payAtTheTable.createCheckActivated || false;
        this.payAtTheTable.scanCheckOnly = company.payAtTheTable.scanCheckOnly || false;
        this.payAtTheTable.disableMultiCheckSelection = company.payAtTheTable.disableMultiCheckSelection || false;
        this.payAtTheTable.tipOnTotal = company.payAtTheTable.tipOnTotal || false;
      }
      await this.setLanguages();
      this.ready = true;
    },

    methods: {
      ...mapActions(["saveCompany"]),
      setTips() {
        let tips = this.payAtTheTable.tipOptions;
        if (tips) {
          this.tipOptions = tips.split(",").map(amount => parseInt(amount));
        } else {
          this.tipOptions = [10, 12, 15, 20];
        }
      },
      async setLanguages() {
        this.languages = await this.$store.getters.getContextLanguages;
        if (!this.languages) {
          let availableLanguages = ['fr', 'en'].filter(l => l !== this.locale);
          this.languages = [this.locale].concat(availableLanguages);
        }
        this.currentLanguageTab = this.languages[0];
      },
      selectedDigitalMenuFile(fileId) {
        this.payAtTheTable.digitalMenu[this.currentLanguageTab].fileId = fileId;
      },
      removeTip(index) {
        this.tipOptions.splice(index, 1);
      },
      cropTable(table) {
        this.payAtTheTable.tables = this.payAtTheTable.tables.replace(table, "").replace(",,", ",");
        if (this.payAtTheTable.tables.charAt(0) === ",") {
          this.payAtTheTable.tables = this.payAtTheTable.tables.substring(1);
        }
      },
      addTip() {
        this.tipOptions.push("");
      },
      async save() {
        if (!this.$validate.valid()) {
          this.$validate.validateAllOnce();
          return;
        }
        this.$store.commit("showSpinner", true);
        let response = await this.saveCompany({
          branchId: this.$route.query.branch,
          companyId: this.$route.query.company,
          augment: "admin",
          data: {
            payAtTheTable: this.payAtTheTable
          }
        });
        this.$store.commit("showSpinner", false);
        if (response) {
          toast(this.$t("company.success"), "success");
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #settingsQRPayment {
    display: flex;
  }

  .logo {
    width: auto;
    height: 50px;
  }

  .input-group {
    align-items: center;

    select {
      flex-grow: 1;
      margin-right: 10px;
    }
  }

  .tip-input {
    max-width: 70px;
    padding: 10px 20px 10px 5px;
    margin-right: 5px;
  }

  .tip {
    position: relative;

    .svgicon {
      cursor: pointer;
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      fill: #ccc;
    }
  }

  .add-tip {
    padding: 5px;
    cursor: pointer;
    fill: var(--primary-color);
  }

  .tables {
    display: flex;
    flex-wrap: wrap;

    .table {
      background-color: #ddd;
      border-radius: 10px;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 5px;
      line-height: 1;

      .svgicon {
        margin-left: 10px;
        cursor: pointer;
        margin-right: 0;
      }
    }
  }

  .feature {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    select {
      width: 170px;
      flex-shrink: 0;
    }

    textarea {
      width: 60%;
    }
  }

  .feature-name {
    flex-grow: 1;
    font-weight: 500;

    &.sub-feature {
      font-weight: normal;
      padding-left: 30px;
      position: relative;

      &::before {
        content: "►";
        padding-right: 10px;
        color: var(--primary-color);
      }
    }
  }
</style>